(function () {
    var soldOutLabel = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
    var handleCache = Object.create(null);
    var pending = Object.create(null);

    function getProductHandle(url) {
        if (!url) return '';
        var match = String(url).match(/\/products\/([^/?#]+)/);
        return match ? match[1] : '';
    }

    function isBuyNowElement(el) {
        if (!el || el.classList.contains('product-card-buy-action--sold-out')) return false;
        if (el.dataset.soldOutChecked === 'true') return false;

        var text = (el.textContent || '').trim();
        if (!/buy now|shop now/i.test(text)) return false;

        if (el.matches('a[href*="/products/"], button[name="add"], .collection-card__buy-btn')) {
            return true;
        }

        return el.matches('.blackFriday1_textRight a, .blackFriday2_textRight a, .blackFriday3_textRight a');
    }

    function markSoldOut(el) {
        el.dataset.soldOutChecked = 'true';

        if (el.tagName === 'BUTTON' && el.closest('form.collection-card__buy-form')) {
            el.type = 'button';
            el.disabled = true;
            el.classList.add('product-card-buy-action--sold-out');
            el.textContent = soldOutLabel;
            return;
        }

        var replacement = document.createElement('span');
        replacement.className = el.className + ' product-card-buy-action--sold-out';
        replacement.setAttribute('aria-disabled', 'true');
        replacement.textContent = soldOutLabel;
        el.replaceWith(replacement);
    }

    function fetchProductAvailability(handle) {
        if (!handle) return Promise.resolve(null);
        if (handleCache[handle] !== undefined) {
            return Promise.resolve(handleCache[handle]);
        }
        if (pending[handle]) return pending[handle];

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        pending[handle] = fetch(root + 'products/' + handle + '.js')
            .then(function (res) {
                if (!res.ok) throw new Error('product unavailable');
                return res.json();
            })
            .then(function (product) {
                handleCache[handle] = !!product.available;
                return handleCache[handle];
            })
            .catch(function () {
                handleCache[handle] = true;
                return true;
            })
            .finally(function () {
                delete pending[handle];
            });

        return pending[handle];
    }

    function resolveHandle(el) {
        if (el.dataset.productHandle) return el.dataset.productHandle;

        if (el.tagName === 'A') {
            return getProductHandle(el.href);
        }

        var form = el.closest('form.collection-card__buy-form');
        if (form) {
            var card = form.closest('.card-wrapper, .product-card, .grid__item, .card');
            var productLink = card && card.querySelector('a[href*="/products/"]');
            return getProductHandle(productLink && productLink.href);
        }

        var scope = el.closest('.blackFriday1_box, .blackFriday2_box, .blackFriday3_box, .product-card, .grid__item');
        if (scope) {
            var scopeLink = scope.querySelector('a[href*="/products/"]');
            return getProductHandle(scopeLink && scopeLink.href);
        }

        return '';
    }

    function processBuyNowElement(el) {
        if (!isBuyNowElement(el)) return;

        var handle = resolveHandle(el);
        if (!handle) return;

        el.dataset.soldOutChecked = 'pending';

        fetchProductAvailability(handle).then(function (available) {
            if (!available) {
                markSoldOut(el);
            } else {
                el.dataset.soldOutChecked = 'true';
            }
        });
    }

    function initStaticBuyNowSoldOut() {
        var selector = [
            'a[href*="/products/"]',
            'button.collection-card__buy-btn',
            '.blackFriday1_textRight a',
            '.blackFriday2_textRight a',
            '.blackFriday3_textRight a'
        ].join(',');

        document.querySelectorAll(selector).forEach(processBuyNowElement);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initStaticBuyNowSoldOut);
    } else {
        initStaticBuyNowSoldOut();
    }
})();
